const config = {
  API_URL: process.env.REACT_APP_API_URL!,
  CP_PUBLIC_ID: process.env.REACT_APP_CP_PUBLIC_ID!,
};

export default config;
